import { useAppDispatch, useAppSelector } from 'src/hooks/store';
import { Button, Spacer, Switch } from '@odekoteam/doppio';
import CancelButton from '../CancelButton';
import { Flex } from 'theme-ui';
import { useEffect, useState } from 'react';
import { modalSelector } from 'src/state/selectors/modal';
import { GetLocation, GetLocationCohort } from 'src/graphql/types/delivery';
import { GUpdateLocationsEnforceItemScanningMutation } from 'src/graphql/types/generated';
import { useMutation } from 'urql';
import { hideModal } from 'src/state/slices/modal';
import { LoaderSpinner } from '../../Loader';
import { updateRoutingLocations } from 'src/state/slices/locations';
import ExpandableLocationsList from './ExpandableLocationsList';
import { UPDATE_LOCATIONS_ENFORCE_ITEM_SCANNING } from 'src/graphql/requests/updateLocationsEnforceItemScanning';

const EnforceItemScanningTab = (): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const {
    variables: { locations },
  } = useAppSelector(modalSelector);
  const [enforceItemScanning, setEnforceItemScanning] = useState<boolean>(true);
  const getLabel = (): string => (enforceItemScanning ? 'ON' : 'OFF');
  const [
    updateLocationsEnforceItemScanningResult,
    updateLocationsEnforceItemScanning,
  ] = useMutation<GUpdateLocationsEnforceItemScanningMutation>(
    UPDATE_LOCATIONS_ENFORCE_ITEM_SCANNING,
  );

  const handleAction = (): void => {
    const locationIds = locations.map(
      (location: GetLocation): string => location.id,
    );
    updateLocationsEnforceItemScanning({
      input: {
        locationIds,
        enforceItemScanning,
      },
    });
  };

  useEffect(() => {
    if (updateLocationsEnforceItemScanningResult.data) {
      const routingLocations = locations.map((location: GetLocation) => ({
        locationId: location.id,
        enforceItemScanning,
      }));
      dispatch(updateRoutingLocations(routingLocations));
      dispatch(hideModal());
    }
  }, [updateLocationsEnforceItemScanningResult]);

  return (
    <>
      <Flex sx={{ alignItems: 'center', marginBottom: '10px' }}>
        <span sx={{ variant: 'text.paragraphMdDefault' }}>
          Update enforce item scanning to:
        </span>
        <div sx={{ marginX: '8px' }}>
          <Switch
            id="enforce-item-scanning-switch-bulk"
            accessibilityLabel="enforce item scanning toggle"
            onCheckedChange={(): void =>
              setEnforceItemScanning(!enforceItemScanning)
            }
            size="default"
            isChecked={enforceItemScanning}
          />
        </div>
        <span sx={{ variant: 'text.paragraphLgDefault' }}>{getLabel()}</span>
      </Flex>
      <div sx={{ variant: 'text.paragraphMdDefault', marginBottom: '20px' }}>
        You will be updating {locations.length} locations. Would you like to
        turn enforce item scanning{' '}
        <b sx={{ variant: 'text.labelMd' }}>{getLabel()}</b> for these{' '}
        {locations.length} locations?
      </div>
      <ExpandableLocationsList locations={locations} />
      <Flex sx={{ justifyContent: 'center', marginTop: '24px' }}>
        {updateLocationsEnforceItemScanningResult.fetching && (
          <LoaderSpinner
            imgStyle={{
              marginLeft: '-200px',
              bottom: '32px',
              height: '20px',
              top: 'auto',
              left: 'auto',
            }}
          />
        )}
        <Button
          id="modal-update-automated-routing-action-button"
          variant="secondary"
          onPress={handleAction}
          isDisabled={updateLocationsEnforceItemScanningResult.fetching}
        >
          Update
        </Button>
        <Spacer width="$1" />
        <CancelButton />
      </Flex>
    </>
  );
};
export default EnforceItemScanningTab;
